import { Slice, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export type dashboardSliceStateType = {

    dateFilter: {
        startDate: string | null;
        endDate: string | null;
    };

    quarter: any
    quarterYear: string

    dateFilterCashflow: {
        startDate: string | null;
        endDate: string | null;
    };
    cashflowQuarter: any
    cashflowQuarterYear: string

};

const initialState: dashboardSliceStateType = {

    dateFilter: {
        startDate: null,
        endDate: null,
    },

    quarter: [],
    quarterYear: '',
    dateFilterCashflow: {
        startDate: '',
        endDate: '',
    },
    cashflowQuarter: [],
    cashflowQuarterYear: ''

};

const dashboardSlice: Slice<dashboardSliceStateType> = createSlice({
    name: "dashboard",
    initialState,
    reducers: {
        setDateFilter: (state, action: PayloadAction<{ startDate: string; endDate: string }>) => {
            state.dateFilter = action.payload;
        },
        setQuarter: (state, action: PayloadAction<any[] | []>) => {
            state.quarter = action.payload;
        },
        setQuarterYear: (state, action: PayloadAction<string>) => {
            state.quarterYear = action.payload;
        },
        setCashflowDateFilter: (state, action: PayloadAction<{ startDate: string; endDate: string }>) => {
            state.dateFilterCashflow = action.payload;
        },
        setCashflowQuarter: (state, action: PayloadAction<any[] | []>) => {
            state.cashflowQuarter = action.payload;
        },
        setCashflowQuarterYear: (state, action: PayloadAction<string>) => {
            state.cashflowQuarterYear = action.payload;
        },
    },
});

export const {
    setDateFilter,
    setQuarter,
    setQuarterYear,
    setCashflowDateFilter,
    setCashflowQuarter,
    setCashflowQuarterYear,

} = dashboardSlice.actions;
export default dashboardSlice.reducer;